import type { EditorPlugin } from '../../../types/aha-editor';
import ItalicMarkPlugin from './ItalicMarkPlugin';
import MarkdownPlugin from '../../MarkdownPlugin/MarkdownPlugin';
import { markdownRegexpForMark } from '../../MarkdownPlugin/MarkdownUtils';

const ItalicMarkdownPlugin: EditorPlugin = {
  name: 'Italic Markdown plugin',
  dependencies: [MarkdownPlugin, ItalicMarkPlugin],
  markdown: [
    {
      regex: markdownRegexpForMark('*'),
      triggerCharacter: '*',
    },
    {
      regex: markdownRegexpForMark('_'),
      triggerCharacter: '_',
    },
  ].map((options) => ({
    type: 'mark',
    mark: 'italic',
    ...options,
  })),
};

export default ItalicMarkdownPlugin;
